import { Env } from '@/configs'
import { useRouting } from '@/hooks'
import axios from 'axios'
import { useEffect, useMemo } from 'react'
import { useAlert } from '../alert/alert.context'
import { useAuth } from '../auth/auth.context'
import { ApiErrorHandler } from './errorHandler.service'

export function useBaseAPI() {
  const { sendAlert } = useAlert()
  const { unAuthorize } = useAuth()
  const { navigate } = useRouting()

  const errorHandler = useMemo(() => {
    return new ApiErrorHandler({
      sendAlert,
      unAuthorize,
      navigate,
    })
  }, [sendAlert, unAuthorize, navigate])

  const instance = useMemo(() => {
    const baseURL = process.env[Env.REACT_APP_API_URL] ?? 'https://localhost:8080'
    return axios.create({
      baseURL,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    })
  }, [])

  useEffect(() => {
    const responseInterceptor = instance.interceptors.response.use((response) => {
      return response
    }, errorHandler.handleError)

    return () => {
      instance.interceptors.response.eject(responseInterceptor)
    }
  }, [instance, errorHandler])

  const canceler = new AbortController()

  return { instance, canceler }
}
